import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { ApiService } from '@shared/services';
import { SFAccount } from '@shared/entities/sf-account';

const LOG_PREFIX = '[Api][AccountSFContact] ';

@Injectable({
  providedIn: 'root'
})
export class AccountSFContactIdService extends ApiService<SFAccount> {
  constructor() {
    const masterUrl = '/account/contact';
    const detailUrl = '/account/contact';
    super(SFAccount, masterUrl, detailUrl, undefined, 'account-sfcontact');
  }

  getAccountByContactId(contactId: string): Observable<SFAccount | null> {
    if (!contactId) {
      return of(null);
    }

    this.logger.debug(LOG_PREFIX + `getAccountByContactId with contactId: ${contactId}`);
    this.setUrlParameter('sfContactId', contactId);

    return this.paginate(SFAccount, 1, 1).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'getAccountByContactId response', response);
        return response.data && response.data.length > 0 ? response.data[0] : null;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + `Error getting account for contact ID ${contactId}:`, error);
        return of(null);
      })
    );
  }
}
